import * as React from 'react';
import * as main from "../../main.module.scss";
import { Modal } from "../../../../Modal";
export const Hinder = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={main.hugs}>
      <div className="container">
        <div className={`${main.container} ${main.violet}`}>
          <h2 className={main.title}>Так же разберём что делать, если учебе мешают:</h2>
          <ul className={main.listTriple}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/problem-01.png" alt=""/>
              <p>Травля (булинг)</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/problem-02.png" alt=""/>
              <p>Конфликты с педагогами</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/problem-03.png" alt=""/>
              <p>Особенности здоровья</p>
            </li>
          </ul>
          <div className={main.centeredBtnBlock}>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Это мне точно нужно!</button>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
